// extracted by css-extract-rspack-plugin
export default {"anchorWithStickyNavbar":"anchorWithStickyNavbar_fF9Z","anchorWithHideOnScrollNavbar":"anchorWithHideOnScrollNavbar_Yh18"};